// Module
var code = "<div class=\"fpd-uncollapsed-menu fpd-visible-hidden fpd-hidden\"></div> <div class=\"fpd-collapsed-menu fpd-hidden\"> <div class=\"fpd-dropdown-btn\"> <i></i> <span class=\"fpd-label\"></span> <div class=\"fpd-dropdown-menu fpd-shadow-1\"></div> </div> </div>";
// Exports
module.exports = code;